import React from 'react';
import styles from './Settings.module.css';

const Settings: React.FC = () => {
  const mockSettings = [
    { id: 'site_name', label: '사이트 이름', value: 'Memory Drawer', type: 'text' },
    { id: 'contact_email', label: '연락처 이메일', value: 'admin@memorydrawer.com', type: 'email' },
    { id: 'maintenance_mode', label: '유지보수 모드', value: false, type: 'toggle' },
    { id: 'max_upload_size', label: '최대 업로드 크기 (MB)', value: 10, type: 'number' },
    { id: 'auto_backup', label: '자동 백업', value: true, type: 'toggle' },
  ];

  return (
    <div className={styles.adminSettings}>
      <h1>시스템 설정</h1>
      
      <div className={styles.settingsForm}>
        {mockSettings.map(setting => (
          <div key={setting.id} className={styles.settingItem}>
            <label htmlFor={setting.id} className={styles.settingLabel}>
              {setting.label}
            </label>
            <div className={styles.settingInput}>
              {setting.type === 'toggle' ? (
                <label className={styles.toggleSwitch}>
                  <input 
                    type="checkbox" 
                    id={setting.id}
                    defaultChecked={setting.value as boolean}
                  />
                  <span className={styles.toggleSlider}></span>
                </label>
              ) : setting.type === 'number' ? (
                <input 
                  type="number" 
                  id={setting.id}
                  defaultValue={setting.value as number}
                  className={styles.inputField}
                />
              ) : (
                <input 
                  type={setting.type} 
                  id={setting.id}
                  defaultValue={setting.value as string}
                  className={styles.inputField}
                />
              )}
            </div>
          </div>
        ))}
        
        <div className={styles.settingsActions}>
          <button className={styles.btnSave}>설정 저장</button>
          <button className={styles.btnReset}>기본값으로 복원</button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
